import { useState, useEffect } from "react";
import { useFormik } from "formik";
import { toast } from 'react-toastify';

import Card from "../../../components/card/card";
import InputForm from "../../../components/input/input";
import DropDown from "../../../components/dropdown/dropdown";
import CalledService from "../../../services/resource/calledService";
import ServiceTypeService from "../../../services/resource/serviceType";
import EmployeeService from "../../../services/resource/employeeService";
import * as Yup from "yup";

import { optionsPriority } from "../../../utils/options";
import { useAuth } from "../../../context/authContext";
import ButtonLoading from "../../../components/buttonLoading/buttonLoading";
import useCommentWebSocket from "../../../utils/useCommentWebSocket ";
import TextareaForm from "../../../components/textarea/textarea";
import UploadComponent from "../../../components/upload/uploadComponent";
import CheckBoxField from "../../../components/checkbox/checkbox";
import CaptureGeolocation from "../../../components/captureGeolocation/captureGeolocation";

const initialValues = {
    title: "",
    description: "",
    requesterEmail: null,
    serviceTypeId: null,
    priority: 0,
    status: 0,
    branchId: null,
    attributes: {},
    sendEmail: true,
}

function AberturaChamado() {
    useCommentWebSocket();
    const calledService = new CalledService();
    const serviceTypeService = new ServiceTypeService();
    const employeeService = new EmployeeService();
    const { user } = useAuth();

    const [serviceType, setServiceType] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [assinatura, setAssinatura] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showLocationButton, setShowLocationButton] = useState(false);

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object({
            title: Yup.string().required("Campo obrigatório"),
            description: Yup.string().required("Campo obrigatório"),
            requesterEmail: Yup.string().email().required("Campo obrigatório"),
            serviceTypeId: Yup.string().required("Campo obrigatório"),
            priority: Yup.string().required("Campo obrigatório"),
            status: Yup.string().required("Campo obrigatório"),
            assigneeId: Yup.string().required("Campo obrigatório"),
            branchId: Yup.string().required("Campo obrigatório"),
        })
    });

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        formik.setValues(prev => ({
            ...prev,
            attributes: {
                ...prev.attributes,
                [name]: value
            }
        }));
    };

    useEffect(() => {
        employeeService.findById(user.userid).then(response => {
            const data = response.data
            formik.setValues(prev => ({
                ...prev,
                branchId: data.branchId,
                requesterEmail: data.email,
                userId: data.email,
            }));
        })

        fetchServicesType();
    }, []);

    useEffect(() => {
        // Limpa os attributes quando o serviceType muda
        formik.setValues(prev => ({
            ...prev,
            attributes: {}
        }));

        // Controla a exibição do componente de geolocalização
        if (formik.values.serviceTypeId === "defe7e9d43da4b0cab67f5b315b4fd89") {
            formik.setValues(prev => ({
                ...prev,
                title: "Atualização de Coordenadas",
                description: "Solicito a alteração de Coordenadas do cliente"
            }))

            setShowLocationButton(true);
        } else {
            setShowLocationButton(false);
        }

        if (formik.values.serviceTypeId === "6263ab62d3304109a0c7a82ac394050e") {
            window.location.href = "/assinatura-de-email"
        }

    }, [formik.values.serviceTypeId]);

    const fetchServicesType = async () => {
        try {

            const response = await serviceTypeService.list();

            const services = await Promise.all(
                response.data.map(async (service) => {

                    try {
                        const image = await serviceTypeService.getImage(service.id);

                        return {
                            ...service,
                            imageUrl: URL.createObjectURL(image.data)
                        };

                    } catch {
                        return {
                            ...service,
                            imageUrl: null
                        };
                    }

                })
            );

            setServiceType(services);

            setAssinatura(
                services.find(x => x.description.includes("Assinat"))
            );

            setTimeout(() => setLoading(false), 400);

        } catch (error) {
            console.error(error);
            toast.error("Erro ao buscar lista de serviços");
        }
    };

    const selectedServiceType = (value) => {
        formik.setFieldValue("serviceTypeId", value);
        setShowModal(false);
    }

    const renderInput = () => {
        const data = serviceType.find(obj => obj.id === formik.values.serviceTypeId);

        if (!data) return null;

        return Object.entries(data.attributes)
            .sort((a, b) => {
                const labelA = a[1].split('___')[1] || '';
                const labelB = b[1].split('___')[1] || '';
                return labelA.localeCompare(labelB);
            })
            .map(([key, value]) => {
                const [type, label] = value.split('___');
                if (type === "checkbox") {
                    return (
                        <div key={key} className="w-full flex items-center">
                            <div id={key} className="flex items-end space-x-2">
                                <CheckBoxField
                                    onChange={formik.handleChange}
                                    name={`attributes.${value}`}
                                    checked={formik.values.attributes[value] || false}
                                />
                                <label htmlFor={key} className="text-sm text-gray-700 items-center">{label || key}</label>
                            </div>
                        </div>

                    );
                } else {
                    return (
                        <div id={key} key={key} className="col-md-12">
                            <InputForm
                                autoComplete="new-password"
                                id={key}
                                type={type || 'text'} // Fallback para 'text' caso 'type' seja undefined
                                label={label || key} // Usa 'key' como fallback caso 'label' seja undefined
                                name={value}
                                maxLength={80}
                                value={formik.values.attributes[value] || ''}
                                onChange={handleInputChange}
                            />
                        </div>
                    );
                }
            });
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        try {
            calledService.validate(formik.values);
        } catch (error) {
            touchedFormik();
            toast.error("Por favor, preencha todos os campos obrigatórios")
            setLoading(false);
            return false;
        }

        try {
            const response = await calledService.createCalled(formik.values);

            if (selectedFiles.length > 0) {
                const formData = new FormData();
                for (let i = 0; i < selectedFiles.length; i++) {
                    formData.append('files', selectedFiles[i]);
                }
                await calledService.savedAttachment(response.data.id, formData);
                setLoading(false);

            } else {
                setLoading(false);
            }

            window.location.href = `/minhas-solicitacoes/ticket/${response.data.ticket}`

        } catch (error) {
            setLoading(false);
            toast.error(error.response.data.message);
        }
    };

    const touchedFormik = () => {
        const entradas = Object.entries(formik.values);

        entradas.forEach(([chave]) => {
            formik.touched[chave] = true
            handleOnBlur(chave);
        });
    }

    const handleOnBlur = (name) => {
        formik.setTouched({ ...formik.touched, [name]: true })
    }

    const closeModal = () => {
        formik.setFieldValue("serviceTypeId", null)
        setShowModal(false);
    }

    useEffect(() => {
        const handleEsc = (event) => {
            if (event.key === "Escape") {
                setShowModal(false);
            }
        };

        if (showModal) {
            document.addEventListener("keydown", handleEsc);
        }

        return () => {
            document.removeEventListener("keydown", handleEsc);
        };
    }, [showModal]);

    return (
        <div className="container">
            <Card title="Abrir Novo Chamado" className="pb-10">
                <form onSubmit={handleSubmit} className="space-y-3">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <InputForm
                                id="InputTitle"
                                type="text"
                                label="Título do Chamado"
                                name="title"
                                disabled={loading}
                                maxLength={256}
                                invalid={formik.touched.title && formik.errors.title}
                                onBlur={formik.handleBlur}
                                value={formik.values.title}
                                onChange={formik.handleChange}
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                <span className={(formik.touched.serviceTypeId && formik.errors.serviceTypeId) ? 'text-red-500' : ''}>Tipo de Serviço <span className="text-red-500">*</span></span>
                            </label>
                            <input
                                id="serviceTypeId"
                                type="button"
                                name="serviceTypeId"
                                className={`w-full px-4 py-2 border-1 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 cursor-pointer bg-white text-left 
                                    ${(formik.touched.serviceTypeId && formik.errors.serviceTypeId) ? 'p-invalid text-red-500 border-red-500' : ''}`
                                }
                                onBlur={formik.handleBlur}
                                value={
                                    serviceType.find((s) => s.id === formik.values.serviceTypeId)?.description || "Selecione um serviço"
                                }
                                onClick={() => setShowModal(true)}
                                readOnly
                            />
                        </div>



                    </div>
                    <div className="flex justify-center" >
                        {showLocationButton && (
                            <CaptureGeolocation formik={formik} setSelectedFiles={setSelectedFiles} />
                        )}
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        {renderInput()}
                    </div>
                    <div className="col-md-12">
                        <TextareaForm
                            id="InputDescription"
                            type="text"
                            label="Descrição Detalhada"
                            name="description"
                            disabled={loading}
                            placeholder="Descreva detalhadamente o problema..."
                            maxLength={5000}
                            rows={4}
                            invalid={formik.touched.description && formik.errors.description}
                            onBlur={formik.handleBlur}
                            value={formik.values.description}
                            onChange={formik.handleChange}
                        />
                    </div>

                    <div className="col-md-12">
                        <UploadComponent onChange={setSelectedFiles} />
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-3">
                        <DropDown
                            id="DropPriority"
                            name="priority"
                            disabled={loading}
                            className="dropdown-custom"
                            style={{ width: "100%" }}
                            options={optionsPriority}
                            label="Prioridade"
                            optionValue="value"
                            optionLabel="label"
                            value={formik.values.priority}
                            onChange={formik.handleChange}
                        />
                    </div>

                    <div className="flex justify-end space-x-1 pt-4 ">
                        <ButtonLoading
                            type="submit"
                            color="green"
                            icon="fas fa-paper-plane"
                            label="Enviar Chamado"
                            loading={loading}
                        >
                        </ButtonLoading>
                    </div>
                </form>
            </Card>

            {showModal === true &&
                <div id="import-modal" className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-5xl min-h-[80vh] max-h-[80vh] fade-in flex flex-col gap-4">
                        <div className="flex justify-between items-center mb-2">
                            <h3 className="text-lg font-medium text-gray-900">Selecione o Motivo da Solicitação</h3>
                            <button id="close-modal" className="text-gray-400 hover:text-gray-500" onClick={closeModal}>
                                <i className="fas fa-times"></i>
                            </button>
                        </div>

                        {/* Body com scroll */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 overflow-y-auto max-h-[100vh] pr-1 pb-4">
                            {serviceType.map((service) => (
                                <div
                                    key={service.id}
                                    className="flex items-center p-3 hover:bg-blue-50 rounded-lg cursor-pointer transition duration-200 border border-gray-100"
                                    onClick={() => selectedServiceType(service.id)}
                                >
                                    <div className="flex-shrink-0 h-8 w-8 flex items-center justify-center overflow-hidden">
                                        {service.imageUrl ? (
                                            <div className="flex-shrink-0 h-8 w-8 flex items-center justify-center overflow-hidden">
                                                {service.imageUrl ? (
                                                    <img
                                                        src={service.imageUrl}
                                                        alt={service.description}
                                                        className="h-full w-full object-contain"
                                                    />
                                                ) : (
                                                    <i className="fas fa-cube text-blue-500 text-xl"></i>
                                                )}
                                            </div>
                                            ) : (
                                            <i className="fas fa-cube text-blue-500 text-xl"></i>
                                        )}
                                    </div>
                                    <div className="ml-3">
                                        <p className="text-sm font-medium text-gray-800">{service.description}</p>
                                    </div>
                                </div>
                            ))}

                        </div>
                    </div>
                </div>
            }
        </div>
    );
};

export default AberturaChamado;

